import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SPEAKERS } from "@/constants/summit";
import { SectionHeading } from "@/components/Reveal";

const SpeakersTeaser = () => (
  <section id="speakers" data-testid="speakers-teaser-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading index="04" kicker="On Stage" title="The voices behind The Choice." />
        <Link
          to="/speakers"
          data-testid="view-all-speakers-button"
          className="group mb-1 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.22em] text-brand-300 transition-colors hover:text-brand-400"
        >
          Explore all speakers
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SPEAKERS.map((s, i) => (
          <motion.div
            key={s.id}
            data-testid="speaker-card-item"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -8, transition: { type: "spring", stiffness: 300, damping: 20 } }}
            className="group relative overflow-hidden rounded-2xl border border-white/10 bg-charcoal"
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={s.image}
                alt={s.name}
                className="h-full w-full object-cover grayscale-[35%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
              <span className="absolute left-4 top-4 rounded-full bg-obsidian/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-brand-300 backdrop-blur-sm">
                {s.category}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-display text-lg font-semibold">{s.name}</h3>
              <p className="mt-1 text-sm text-brand-300">{s.role}</p>
              <p className="text-xs text-white/45">{s.organization}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SpeakersTeaser;
